import React, { useContext } from 'react';
import { Body } from 'js/design_system/Body';
import { TextButton } from 'js/design_system/TextButton';
import { CiterightContext } from './CiterightContextProvider';
import { PaperEvaluationChat } from './components/PaperEvaluationChat';
import WorkCard from './components/WorkCard';

export const DetailsPage: React.FC = () => {
  const context = useContext(CiterightContext);
  const work = context?.activeWork;
  const setActiveWorkId = context?.setActiveWorkId;

  if (!work) {
    return (
      <div>
        <TextButton onClick={() => setActiveWorkId?.(null)}>← Back</TextButton>
        <Body>No work selected</Body>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'flex-start',
        maxHeight: '100vh',
        overflow: 'auto',
      }}
    >
      <TextButton onClick={() => setActiveWorkId?.(null)}>← Back</TextButton>
      <WorkCard
        workData={work}
        showPaperEvaluationChatButton={false}
        pageContext="inline_report"
      />
      <PaperEvaluationChat work={work} />
    </div>
  );
};
